module.exports = __webpack_public_path__ + "static/media/gsod_scoreCard2.d641004c.svg";